<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/mixins";

  .inner {
    align-items: center;
    display: flex;
    gap: utils.in_rem(12px);
  }

  @mixin sticky($position) {
    &.sticky-#{$position} {
      position: sticky;
      @if $position == "left" {
        left: 0;
      } @else if $position == "right" {
        right: 0;
      }
    }
  }

  th {
    border-collapse: collapse;
    @include colors.background-color(interfaceSwGrey_4);

    $border-radius: 8px;

    &:first-child.rounded-header {
      border-radius: $border-radius 0 0 $border-radius;
    }

    &:last-child.rounded-header {
      border-radius: 0 $border-radius $border-radius 0;
    }
    @include sticky(left);
    @include sticky(right);

    .inner {
      @include mixins.overline();
      @include colors.color(textBlack);
      padding: utils.in_rem(4px) utils.in_rem(20px);
      text-transform: uppercase;
    }
  }

  td {
    border-collapse: collapse;
    padding: 0;
    @include sticky(left);
    @include sticky(right);

    .inner {
      @include mixins.body2();
      padding: utils.in_rem(12px) utils.in_rem(20px);
      @include colors.utility_classes();
    }
  }
</style>

<script>
  import { getContext } from "svelte";
  import { IS_HEAD } from "./table-context";

  let cls = "";
  export let zIndex = 0;
  export { cls as class };
  export let colspan = 1;
  export let sticky = null; // null | "left" | "right";
  export let roundedHeader = true;

  // Custom styles for cell content
  export let innerStyle = "";

  let style = `z-index:${zIndex}`;
  const isHead = getContext(IS_HEAD) || false;
  $: outerCls = sticky ? `sticky-${sticky}` : "";
</script>

{#if isHead}
  <th
    {colspan}
    class="{outerCls} {roundedHeader ? 'rounded-header' : ''}"
    {style}
  >
    <div class="inner {cls}" style={innerStyle}>
      <slot />
    </div>
  </th>
{:else}
  <td {colspan} class={outerCls} {style}>
    <div class="inner {cls}" style={innerStyle}>
      <slot />
    </div>
  </td>
{/if}
